import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';





// This functionality is not working we stop it in task DDT-2638, by requirment we wont remove it because we may use it in the feature





/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'cancelButton',
        'submitButton',
        'descriptionTextarea',
    ];

    initialState = {};

    connect() {
        this.saveInitialState();
        window.resetState = this.resetState.bind(this);

        $(this.element).on('hidden.bs.modal', () => {
            this.resetState();
        });

        $(this.descriptionTextareaTarget).summernote({
            toolbar: [
                ['style', ['bold', 'italic']],
                ['para', ['ul', 'ol']],
                ['toggleEditor'],
            ],
            tooltip: false,
            disableResizeEditor: true,
        });
    }

    saveInitialState() {
        $('[name="recruitmentType[]"]').each((index, value) => {
            this.initialState[($(value).attr('id'))] = $(value).is(':checked');
        });
    }

    restoreInitialState() {
        $('[name="recruitmentType[]"]').each((index, value) => {
            ($(value).prop('checked', this.initialState[$(value).attr('id')]));
        });
    }

    openModal() {
        $(this.element).modal({
            backdrop: 'static',
            focus: false,
            show: true,
        });

        dataLayer.push({
            event: 'dataLayer.gaEvent',
            gaEvent: {
                'category': 'Account',
                'action': 'profile_recruitment_open',
                'label': '',
            },
        });
    }

    closeModal() {
        $(this.element).modal('hide');

        this.restoreInitialState();
    }

    resetState() {
        this.submitButtonTarget.disabled = false;
        this.cancelButtonTarget.disabled = false;
    }

    async save() {
        this.submitButtonTarget.disabled = true;
        this.cancelButtonTarget.disabled = true;

        showPreloader();

        const values = [];

        $('[name="recruitmentType[]"]').each((index, value) => {
            if ($(value).is(':checked')) {
                values.push($(value).attr('id'));
            }
        });

        const data = {
            field: 'recruitment',
            value: JSON.stringify(values),
        };

        try {
            const response = await fetch(routes['app_profile_edit'], {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: new URLSearchParams(data),
            });

            const isSuccess = (await response.json()).status;

            if (isSuccess) {
                const data = {
                    field: 'recruitment_description',
                    value: $(this.descriptionTextareaTarget).summernote('code'),
                };

                const response = await fetch(routes['app_profile_edit'], {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    body: new URLSearchParams(data),
                });

                const isSuccess = (await response.json()).status;

                if (isSuccess) {
                    dataLayer.push({
                        event: 'dataLayer.gaEvent',
                        gaEvent: {
                            'category': 'Account',
                            'action': 'profile_recruitment_update',
                            'label': '',
                        },
                    });

                    window.location.reload();
                } else {
                    addAlert('danger', translations['profile.An unknown error occurred.']);
                }

                return;
            } else {
                addAlert('danger', translations['profile.An unknown error occurred.']);
            }
        } catch (error) {
            addAlert('danger', translations['profile.An unknown error occurred.']);
        }

        this.submitButtonTarget.disabled = false;
        this.cancelButtonTarget.disabled = false;

        hidePreloader();
    }
}
